export default __webpack_public_path__ + "static/media/FJ.c2083bee.svg";